import React from "react";
import { Pressable, Text, View } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { GlobalStyles } from "../style/Style";
import { CheckmarkIcon } from "../icons/CheckmarkIcon";

export interface CheckboxProps {
    checked: boolean;
    title?: string;
    labelOverride?: JSX.Element;
    onChange: (...args: any[]) => void;
    testID?: string;
}

export const CheckBox: React.FC<CheckboxProps> = ({
    checked,
    title = "",
    labelOverride,
    onChange: onPress,
    testID,
}) => {
    const styles = useDynamicStyles(generateStyles);
    return (
        <Pressable testID={testID} style={[styles.checkboxContainer]} onPress={onPress}>
            <View style={[styles.checkbox, checked && styles.checked]}>
                <View style={styles.innerCheckbox}>
                    {checked && <CheckmarkIcon fill={EStyleSheet.value(GlobalStyles.CHECKBOX_CHECKED)} />}
                </View>
            </View>
            {labelOverride}
            {!labelOverride && <Text style={styles.label}>{title}</Text>}
        </Pressable>
    );
};

const generateStyles = () => {
    return EStyleSheet.create({
        checkboxContainer: {
            width: "100%",
            height: 30,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 5,
        },
        checkbox: {
            width: 30,
            height: 30,
            borderWidth: () => EStyleSheet.value(GlobalStyles.BORDER_THICKNESS),
            borderColor: () => EStyleSheet.value(GlobalStyles.CHECKBOX_BORDER),
            backgroundColor: () => EStyleSheet.value(GlobalStyles.CHECKBOX_BACKGROUND),
            borderRadius: 8,
        },
        checked: {
            borderColor: () => EStyleSheet.value(GlobalStyles.CHECKBOX_CHECKED),
        },
        innerCheckbox: {
            width: 26,
            height: 26,
            borderWidth: () => EStyleSheet.value(GlobalStyles.BORDER_THICKNESS),
            borderColor: "#ffffff",
            backgroundColor: () => EStyleSheet.value(GlobalStyles.CHECKBOX_BACKGROUND),
            borderRadius: 8,
            justifyContent: "center",
            alignItems: "center",
        },
        label: {
            fontSize: 14,
            paddingLeft: 10,
            fontWeight: "600",
            color: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
            fontFamily: () => EStyleSheet.value(GlobalStyles.BASE_FONT),
        },
    });
};
